import { html, ifDefined } from 'omni-ui';
import { mergeClass, Om2FormFieldBase, SHARED_FIELD } from './common/base.js';

/**
 * Render a single-line string input
 */
export class Om2FormFieldString extends Om2FormFieldBase {
  static metadata = {
    config: {
      label: 'Text Input',
      overrides: {
        type: 'string',
      },
      fields: {
        id: SHARED_FIELD,
        title: SHARED_FIELD,
        tooltip: SHARED_FIELD,
        class: SHARED_FIELD,
        default: SHARED_FIELD,
        placeholder: SHARED_FIELD,
        required: SHARED_FIELD,
        disabled: SHARED_FIELD,
        readonly: SHARED_FIELD,
      },
    },
  };

  render() {
    const { schema } = this;
    return html`<input
      class=${mergeClass('input', schema.class)}
      .name="${this.key}"
      .value=${this.data ?? schema.default ?? ''}
      placeholder=${ifDefined(schema.placeholder)}
      pattern=${ifDefined(schema.pattern)}
      title=${ifDefined(schema.htmlTitle)}
      ?required=${schema.required}
      ?disabled=${schema.disabled || this._isHidden()}
      ?readonly=${schema.readonly || this.context?.readonly}
    />`;
  }
}

Om2FormFieldString.register('string');
